import React, { useEffect } from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import ProductDetail from "../../components/product/ProductDetail";
import NewArrivalTwo from "../../components/NewArrivalTwo";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import BreadcrumbTwo from "./../../components/BreadcrumbTwo";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
import useProductBySlug from "../../hooks/useProductBySlug";
import { useParams, useNavigate } from "react-router-dom";

const ProductDetailsPage = ({ isWholesale = false }) => {
  const navigate = useNavigate();
  const { slug } = useParams(); // Assuming you are using react-router-dom to get the slug from the URL

  const {
    fetchProductBySlug,
    data: product,
    status: productStatus,
    error: productError,
  } = useProductBySlug();

  useEffect(() => {
    if (slug) {
      fetchProductBySlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    if (product && product?.isGrosir !== isWholesale) {
      // redirect to the correct product using react-router-dom's useNavigate
      console.log(
        "Redirecting to product details page for slug:",
        product.slug,
      );
      navigate(`/product-details/${encodeURIComponent(product.slug)}`);
    }
  }, [product, isWholesale]);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* HeaderOne */}
      <HeaderOne isWholesale={isWholesale} />

      {/* Breadcrumb */}
      <BreadcrumbTwo
        title={isWholesale ? "Wholesale Product Details" : "Product Details"}
        breadcrumbTitle={"Product Detail"}
      />

      {/* ProductDetail */}
      <ProductDetail product={product} isWholesale={isWholesale} />

      {/* NewArrivalTwo */}
      <NewArrivalTwo productId={product?.id} isWholesale={isWholesale} />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProductDetailsPage;
